import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

import config from "appConfig";

const items = [
  {
    id: "f0c5c7c1-3368-4a96-9487-e60860a9d4f1",
    content: "Answer 1",
    options: { image: `${config.ASSETS_URL}/03/22/task/task-2-answer-1.svg` },
  },
  {
    id: "1985a2c0-9c87-4e1a-a961-862f7abd5448",
    content: "Answer 2",
    options: { image: `${config.ASSETS_URL}/03/22/task/task-2-answer-2.svg` },
  },
  {
    id: "0fcc1dfe-6c59-40b9-980c-16dcd737cdef",
    content: "Answer 3",
    options: { image: `${config.ASSETS_URL}/03/22/task/task-2-answer-3.svg` },
  },
  {
    id: "7a8c528c-400a-4c83-ad83-ac6887c6bfa1",
    content: "Answer 4",
    options: { image: `${config.ASSETS_URL}/03/22/task/task-2-answer-4.svg` },
  },
];

export const task: Task = {
  id: "6008b4ab-d227-4faa-a3f3-23acdc177e7c",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["1985a2c0-9c87-4e1a-a961-862f7abd5448", "0fcc1dfe-6c59-40b9-980c-16dcd737cdef"],
};
